module.exports = __webpack_public_path__ + "img/2025.bf9ff04e.jpg";